import { render, staticRenderFns } from "./surface_post_reaction_vote.vue?vue&type=template&id=5e1036cb&scoped=true&"
import script from "./surface_post_reaction_vote.vue?vue&type=script&lang=js&"
export * from "./surface_post_reaction_vote.vue?vue&type=script&lang=js&"
import style0 from "./surface_post_reaction_vote.vue?vue&type=style&index=0&id=5e1036cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e1036cb",
  null
  
)

export default component.exports